import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Layout, Spin } from 'antd';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';
import IntroSign from '../../components/sign/Intro';
import SignDocument from '../../components/sign/SignDocument';
import SuccessSign from '../../components/sign/Success';
import SuccessDemur from '../../components/sign/SuccessDemur';
import Fail from '../../components/sign/Fail';
import decode from '../../helpers/urlParamDecode';
import { STATUS } from '../../config/constants/states';
import { GET_CONTRACT_DATA_FORM, VERIFY_TOKEN } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import { STATES } from '../../config/constants/contractStates';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;

const SignContract = ({ getContract, verifyToken, tokenStatus }) => {

  const { params } = useParams();
  const [current, setCurrent] = useState(0);
  const [tokenParams, setTokenParams] = useState('');
  const [valid, setIfValid] = useState(true);
  const [loaderSpinning, setLoaderSpinning] = useState(true);

  useEffect(() => {
    verifyToken(params);
    const data = decode(params);
    setTokenParams(data);
    if (data[0]) {
      getContract(data[0]);
    }
  }, []);

  useEffect(() => {
    if (tokenParams === STATUS.ERROR) {
      setIfValid(false);
      setLoaderSpinning(false);
    }
    if (tokenStatus !== '') {
      if (tokenStatus === STATES.CREATED || tokenStatus === STATES.AWAITING_VALIDATION) {
        setLoaderSpinning(false);
      } else {
        setIfValid(false);
        setLoaderSpinning(false);
      }
    }
  }, [tokenParams, tokenStatus]);

  return (
    <>
      {loaderSpinning
        ? <Spin className="spin-centered" tip="Cargando..."></Spin>
        : <>
          {valid ?
            <>
              <Header className="header-container">
                <Row className="header-logos mb-0">
                  <img src={LegalChileLogo} alt="" className="legal-logo" />
                  <img src={TramittaLogo} alt="" className="tramitta-logo" />
                </Row>
              </Header>
              <Content className="ant-layout-content-custom" style={{ overflowX: 'hidden' }}>
                {current === 0 && <IntroSign changeView={setCurrent} />}
                {current === 1 && <SignDocument changeView={setCurrent} tokenParams={tokenParams} />}
                {current === 2 && <SuccessSign changeView={setCurrent} />}
                {current === 3 && <SuccessDemur changeView={setCurrent} />}
              </Content>
            </>
            : <Fail />
          }
        </>
      }
    </>
  );
};

SignContract.propTypes = {
  getContract: PropTypes.func.isRequired,
  verifyToken: PropTypes.func.isRequired,
  tokenStatus: PropTypes.string.isRequired,
};

const data = (state) => ({
  tokenStatus: state.contract.tokenStatus,
});

const action = (dispatch) => ({
  verifyToken: (token) => dispatch({ type: VERIFY_TOKEN, payload: token }),
  getContract: (id) => dispatch({ type: GET_CONTRACT_DATA_FORM, payload: { id, resource: RESOURCE.GET_CONTRACT } }),
});

export default connect(data, action)(SignContract);